import { useTranslation } from 'react-i18next';

export default function TradingToolsSection() {
  const { t } = useTranslation();

  const tools = [
    {
      title: t('platform.mw'),
      description: t('platform.rtp'),
      image: '/img/790f3bf77be2e344b48c7f8552cf269c.jpg'
    },
    {
      title: t('platform.om'),
      description: t('platform.aot'),
      image: '/img/975d27c9883320d4f854873d4c3d7205.jpg'
    },
    {
      title: t('platform.ta'),
      description: t('platform.cta'),
      image: '/img/3e7e25cbd8292736767cae951e79e9a8.jpg'
    }
  ];

  return (
    <section className="py-20 relative overflow-hidden">

      {/* ✅ 背景圖片 */}
      <div className="absolute inset-0 z-0">
        <img
          src="/img/platform_bg1.jpg"
          className="w-full h-full object-cover opacity-10"
          alt="background"
        />
      </div>

      {/* ✅ 內容層（要有 z-10） */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('platform.ptt')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('platform.aig')}
          </p>
        </div>
        
        <div className="grid lg:grid-cols-3 gap-8">
          {tools.map((tool, index) => (
            <div key={index} className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-xl shadow-lg mb-6">
                <img
                  src={tool.image}
                  alt={tool.title}
                  className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute bottom-4 left-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-external-link-line text-2xl"></i>
                </div>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {tool.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {tool.description}
              </p>
            </div>
          ))}
        </div>

        {/* Additional Features */}
        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="text-center p-6 bg-gray-50/80 backdrop-blur rounded-xl">
            <i className="ri-time-line text-3xl text-amber-600 mb-4"></i>
            <h4 className="font-bold text-gray-900 mb-2">{t('platform.rtd')}</h4>
            <p className="text-sm text-gray-600">{t('platform.lmd')}</p>
          </div>

          <div className="text-center p-6 bg-gray-50/80 backdrop-blur rounded-xl">
            <i className="ri-notification-line text-3xl text-amber-600 mb-4"></i>
            <h4 className="font-bold text-gray-900 mb-2">{t('platform.pa')}</h4>
            <p className="text-sm text-gray-600">{t('platform.caf')}</p>
          </div>

          <div className="text-center p-6 bg-gray-50/80 backdrop-blur rounded-xl">
            <i className="ri-history-line text-3xl text-amber-600 mb-4"></i>
            <h4 className="font-bold text-gray-900 mb-2">{t('platform.this')}</h4>
            <p className="text-sm text-gray-600">{t('platform.cth')}</p>
          </div>

          <div className="text-center p-6 bg-gray-50/80 backdrop-blur rounded-xl">
            <i className="ri-calendar-line text-3xl text-amber-600 mb-4"></i>
            <h4 className="font-bold text-gray-900 mb-2">{t('platform.ec')}</h4>
            <p className="text-sm text-gray-600">{t('platform.suw')}</p>
          </div>
        </div>
      </div>
    </section>
  );
}